import React from 'react';
import {useTranslation} from 'react-i18next';
import {FormErrorMessage} from '../../../../form-features/FormErrorMessage';
import {SelectStructure} from '../SelectStructure';
import Select from 'react-select';

export function RawSelect({
    disabled,
    label,
    prefix,
    children,
    options,
    defaultValue,
    onChange,
    validationError,
    placeholder,
    ...props
}) {
    const {t} = useTranslation();
    return (
        <SelectStructure
            label={label}
            prefix={prefix}
            disabled={disabled}
            errorMessage={<FormErrorMessage>{validationError && <>{validationError}</>}</FormErrorMessage>}>
            <Select
                {...props}
                placeholder={placeholder || t('searchableDropdown.placeholder')}
                classNamePrefix="dropdown-select"
                options={options}
                defaultValue={defaultValue}
                onChange={onChange}
                isDisabled={disabled}
            />
            {children}
        </SelectStructure>
    );
}
